<template>
  <div class="form-list">
    <el-form
      ref="form"
      class="form"
      label-position="left"
      label-width="160px"
    >
      <el-form-item label="ID">{{ id }}</el-form-item>
      <el-form-item label="昵称">{{ teacher.nickname }}</el-form-item>
      <el-form-item label="头像">
        <v-avatar :value="teacher.avatar" :size="50"/>
      </el-form-item>
      <el-form-item label="手机号">{{ teacher.phone }}</el-form-item>
      <el-form-item label="所属门店">{{ teacher.store_names }}</el-form-item>
      <el-form-item label="企业微信号">{{ teacher.we_chat }}</el-form-item>
      <el-form-item label="微博号">{{ teacher.micro_blog }}</el-form-item>
      <el-form-item label="美拍号">{{ teacher.mei_pai }}</el-form-item>
      <el-form-item label="个人简介">
        <p class="article">{{ teacher.brief }}</p>
      </el-form-item>

      <el-form-item>
        <router-link :to="RouteConfig.teacherEdit.to(id)" class="button-link">
          <el-button type="primary">修改资料</el-button>
        </router-link>
        <el-button @click="RouteConfig.teacherList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from "@/router/config";
import { mapGetters } from 'vuex';
import { show } from '@/api/teacher';
import { index } from '@/api/store';

export default {
  name: RouteConfig.teacherDetail.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    teacher: {
      nickname: '',
      phone: '',
      we_chat: '',
      micro_blog: '',
      mei_pai: '',
      avatar: '',
      brief: '',
      is_hide_in_list: 0,

      video_count: 0,
      view_count: 0,
      video_name: '',
      dynamic_name: '',
      blessing: '',

      store_names: '',
    },
    stores: [],
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;
      this.teacher = data;
    },
    async getStores() {
      const { isError, data } = await index({ is_only_name: 1 });
      if (isError) return;

      this.stores = data;
    },
  },
  beforeMount() {
    this.getStores();
    this.show();
  },
};
</script>
